<template>
  <label class="font-regular text-sm flex items-center">
    <input
      type="radio"
      style="border: 1px solid !important"
      :value="value"
      :checked="value === modelValue"
      @change="$emit('update:modelValue', value)"
    >

    <span class="pl-1.5" :style="{ paddingTop: `1px` }">
      {{ label }}
    </span>
  </label>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
    props: {
        label: {
            type: String,
            required: true
        },

        value: {
            type: [
                String,
                Number,
                Boolean
            ],

            required: true
        },

        modelValue: {
            type: null,
            required: true
        }
    },
    emits: ['update:modelValue']
});
</script>
